import { ButtonBase, styled as muiStyled } from '@mui/material'

export const GenericTimerStartPracticeButton = muiStyled(ButtonBase)(
  ({ theme }) => `
    padding: 6px 84px;
    border-radius: 5px;
    background-color: #7B49E5;
    color: #fff;
    font-size: 18px;
    border: 1px solid transparent;
    transition: all 400ms ${theme.transitions.easing.quickInOut};
    &:disabled {
      background: #958fa3;
      color: #000;
    }
    &:hover {
      background: #6524f0;
      border: 1px solid #ffffff2b;
    }
`,
)

export const AdditionalOptionsButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  padding: 2px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 50px;
  color: #fff;
  gap: 5px;
  transition: all 400ms ${theme.transitions.easing.quickInOut};
  font-size: 14px;
  &:hover {
    background: #ffffff2b;
  }
`,
)

export const GenericTimerButtonsAndSettingsContainer = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin: 30px 0px 0px 0px;
`,
)
